<template>
  <span class="regular-12 text-black text-center">
    <button class="btn btn-secondary btn-sm" v-on:click="showModal = true">
      <BaseIcon name="calendar" />
    </button>
    <LeaveModal
      v-model:show="showModal"
      :member-id="id"
      :member-name="memberName"
      :type="row?.path_id || 'teams'"
    />
  </span>
</template>

<script>
import BaseIcon from "../../icons/BaseIcon";
import LeaveModal from "../../modals/LeaveModal";

export default {
  name: "LeaveButton",
  components: { LeaveModal, BaseIcon },
  props: {
    id: Number,
    main: Number,
    type: String,
    row: Object,
    modelValue: String,
  },
  data() {
    return {
      showModal: false,
      value: this.modelValue,
      memberName: "",
    };
  },
  watch: {
    value() {
      this.$emit("update:modelValue", this.value);
      this.$emit("change");
    },
    modelValue() {
      this.value = this.modelValue;
    },
    showModal() {
      if (this.showModal) {
        this.memberName = "";
      }
    },
  },
  emits: ["update:modelValue", "change"],
};
</script>
